'use client';

import { MdOutlineSchedule } from 'react-icons/md';
import useCountdown from '../utils/useCountdown';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

export default function AuctionTimer({ end }: { end: string | number | Date }) {
  const t = useTranslations('AuctionTimer');
  const countDown = useCountdown(end);
  const [mounted, setMounted] = useState(false);
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  if (!mounted) {
    setTimeout(() => {
      setMounted(true);
    }, 1000);
  }

  return (
    <div
      className={`${!mounted ? 'text-transparent ' : ''}mt-2 relative flex w-full items-center justify-center gap-1 overflow-hidden border-t border-white/50 pt-2 font-semibold`}
    >
      {countDown > 0 && (
        <>
          <MdOutlineSchedule />
          {!!days && (
            <>
              {days}
              {t('days')[0].toLowerCase()}
            </>
          )}
          {(!!days || !!hours) && (
            <>
              {' '}
              {hours}
              {t('hours')[0].toLowerCase()}
            </>
          )}
          {!days && (
            <>
              {' '}
              {minutes}
              {t('min')[0].toLowerCase()}
            </>
          )}
          {!days && !hours && (
            <>
              {' '}
              {seconds}
              {t('sec')[0].toLowerCase()}
            </>
          )}
        </>
      )}
      {countDown <= 0 && t('ended')}
      <div
        className={`absolute h-full w-full bg-black transition-all duration-700 ${mounted ? 'bottom-full' : 'bottom-0'}`}
      />
      <div
        className={`absolute h-full w-full bg-black transition-all duration-700 ${mounted ? 'top-full' : 'top-0'}`}
      />
    </div>
  );
}
